var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconFilter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h32v32H0z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: props.color
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25 7c0 .366-.105.705-.278 1-.347.595-.986 1-1.722 1a1.995 1.995 0 01-1.722-1A1.968 1.968 0 0121 7c0-.366.105-.705.278-1 .347-.595.986-1 1.722-1s1.375.405 1.722 1c.173.295.278.634.278 1zm1.858-1c-.447-1.72-2-3-3.858-3s-3.411 1.28-3.858 3H2v2h17.142c.447 1.721 2 3 3.858 3s3.41-1.279 3.858-3H30V6h-3.142zM11 16c0 .366-.105.705-.278 1-.347.595-.986 1-1.722 1a1.995 1.995 0 01-1.722-1A1.968 1.968 0 017 16c0-.366.105-.705.278-1 .347-.595.986-1 1.722-1s1.375.405 1.722 1c.173.295.278.634.278 1m-2-4c-1.858 0-3.411 1.28-3.858 3H2v2h3.142c.447 1.721 2 3 3.858 3s3.41-1.279 3.858-3H30v-2H12.858c-.447-1.72-2-3-3.858-3M20 25c0 .366-.105.705-.278 1-.347.595-.986 1-1.722 1a1.995 1.995 0 01-1.722-1A1.968 1.968 0 0116 25c0-.366.105-.705.278-1 .347-.595.986-1 1.722-1s1.375.405 1.722 1c.173.295.278.634.278 1m-2-4c-1.858 0-3.411 1.28-3.858 3H2v2h12.142c.447 1.721 2 3 3.858 3s3.41-1.279 3.858-3H30v-2h-8.142c-.447-1.72-2-3-3.858-3"
  })))));
}

export default SvgIconFilter;